export default __webpack_public_path__ + "static/media/job_offer9_m.f746862d.jpg";